import { UseQueryOptions } from '@tanstack/react-query';

import { DisplayTemplate } from '@crossnokaye/typescript-sdk/models/components';

import { equipmentBrowserPreviewEquipmentDetailsView } from '@repo/sdk/funcs/equipmentBrowserPreviewEquipmentDetailsView';
import { EquipmentDetailsResponse } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { PreviewEquipmentDetailsViewRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';
import { hashValue } from '@/utils/hash';

interface PreviewEquipmentDetailsQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  deviceId: string;
  displayTemplate: DisplayTemplate;
}

export const previewEquipmentDetailsQuery = ({
  agentId,
  deviceId,
  client,
  displayTemplate,
}: PreviewEquipmentDetailsQueryProps): UseQueryOptions<
  EquipmentDetailsResponse,
  SDKError,
  EquipmentDetailsResponse | undefined
> => {
  const templateHash = hashValue(displayTemplate);

  return {
    enabled: !!agentId && !!deviceId,
    queryKey: [agentId, 'previewEquipmentDetails', deviceId, templateHash],
    queryFn: () =>
      client<PreviewEquipmentDetailsViewRequest, EquipmentDetailsResponse>({
        gaiaFunc: equipmentBrowserPreviewEquipmentDetailsView,
        request: {
          agentId: agentId!,
          deviceId: deviceId!,
          body: {
            displayTemplate: JSON.stringify(displayTemplate),
          },
        },
      }),
    staleTime: Infinity,
  };
};
